import React from 'react';

const DragHandle = ({ height = 24, width = 24, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title>ic drag handle 24px</title>
    <g fill={color}>
      <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z"/>
    </g>
  </svg>
);

export default DragHandle;
